

































import { Vue, Component, Prop } from 'vue-property-decorator'
import { IDialog } from '@/model/index'

@Component
export default class ConfirmDialog extends Vue {
  @Prop() private value: boolean = false
  @Prop() private dialogProps!: IDialog

  private resolve: any = () => { return false }

  get show () {
    return this.value
  }
  set show (value) {
    this.$emit('input', value)
  }

  get acceptColor (): string {
    return this.dialogProps!.acceptColor || 'success'
  }

  private accept () {
    this.$emit('accept')
    // this.active = false
    this.resolve(true)
  }

  private cancel () {
    // this.active = false
    this.$emit('cancel')
    this.resolve(true)
  }

  private pop () {
    this.show = true
    return new Promise((resolve, reject) => {
      this.resolve = resolve
    })
  }

}

